var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('section')])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }